import type { SelectorObject } from '../types';

export const fixedChargeEditVariantsListItemSelectors = {
  trashButton: 'fixed-charge-edit-variants-list-item-trash-button',
} satisfies SelectorObject<'fixed-charge-edit-variants-list-item-'>;